import Vue from 'vue';
import ApolloClient from 'apollo-boost';
import gql from 'graphql-tag';
import VueApollo from 'vue-apollo';
import eventBus from '@/lib/event-bus';
import { getToken, removeToken } from '@/lib/token';
import { ADMIN_APP_KEY, BACKEND_BASE_URL, FRONTEND_BASE_URL } from '@/globals';
import { install as installDirectives } from '@/directives';
import App from './app.vue';
import router from './router';

const getKeyFromLocation = () => window.location.pathname.split('/')[1];

async function getTheme(client) {
  const key = getKeyFromLocation();
  if (!key) {
    return null;
  }
  const { data: { app } } = await client.query({
    query: gql`query ($key: String!) {
      app (key: $key) {
        theme
      }
    }`,
    variables: { key },
  });
  return app && app.theme;
}

const apolloClient = new ApolloClient({
  onError: () => {
    if (window.location.href.includes('admin') && !window.location.href.includes(`${ADMIN_APP_KEY}/sign-in`)) {
      window.location.href = `${FRONTEND_BASE_URL}/${ADMIN_APP_KEY}/sign-in`;
      removeToken(true);
    }
  },
  request: (operation) => {
    const key = getKeyFromLocation();
    if (!key) {
      return;
    }
    const isAdmin = key === 'admin' || key === ADMIN_APP_KEY;
    const token = getToken(isAdmin);
    if (token) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
    }
  },
  uri: BACKEND_BASE_URL,
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $query: {
      fetchPolicy: 'no-cache',
    },
  },
});

Vue.config.productionTip = false;

installDirectives(Vue);

Vue.use(VueApollo);

Vue.use({
  install(app) {
    const a = app;
    a.prototype.$eventBus = eventBus;
  },
});

getTheme(apolloClient).then((theme) => {
  new Vue({
    router,
    apolloProvider,
    render: (h) => h(App, {
      props: { theme },
    }),
  }).$mount('#app');
});
